import { render, staticRenderFns } from "./PAF01_Core.vue?vue&type=template&id=7c40a4ec&scoped=true&"
import script from "./PAF01_Core.vue?vue&type=script&lang=js&"
export * from "./PAF01_Core.vue?vue&type=script&lang=js&"
import style0 from "./PAF01_Core.vue?vue&type=style&index=0&id=7c40a4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c40a4ec",
  null
  
)

export default component.exports